import { render, staticRenderFns } from "./AvatarWrapper.vue?vue&type=template&id=6498d3b8&scoped=true"
import script from "./AvatarWrapper.vue?vue&type=script&lang=js"
export * from "./AvatarWrapper.vue?vue&type=script&lang=js"
import style0 from "./AvatarWrapper.vue?vue&type=style&index=0&id=6498d3b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6498d3b8",
  null
  
)

export default component.exports